// **  Initial State
const initialState = {
    baseUrl : process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'https://api-dev.afts.biz/platform/',
    locale: "en"
}
const configReducer = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_LOCALE':
      return { ...state, locale:action.locale }
    default:
      return state
    }
}
  
 
export default configReducer
  